// External libraries
import React from 'react';
import { string } from 'prop-types';

// Internal modules
import { logTermClick } from './utils';
import { TERMS_MAP } from './constants';
import { TermsLink } from '@/components/Common';
import { buildTermsUrl, getContent, getNestedContentKeys } from '@/lib';

const getTermsLinks = termsKey => {
  const termsLinks = getNestedContentKeys(termsKey);
  if (!Array.isArray(termsLinks)) {
    return {};
  }

  return termsLinks.reduce((termsObj, link) => {
    termsObj[link] =
      link === 'brTag' ? (
        <br />
      ) : (
        <TermLink linkName={link} {...TERMS_MAP[link]} />
      );
    return termsObj;
  }, {});
};

const TermLink = props => {
  const { contentKey, ...rest } = props;
  const termsKey = `billingAgreement.${contentKey}`;
  const content = getContent(termsKey);
  return (
    <TermsLink
      clickHandler={() => logTermClick(contentKey)}
      href={buildTermsUrl(rest)}
      text={content}
    />
  );
};

TermLink.propTypes = {
  contentKey: string.isRequired,
  path: string.isRequired,
};

export { getTermsLinks, TermLink };
